export type IsoDate = string;

export interface DateRange {
    start: IsoDate;
    end: IsoDate;
}

export const isDateRange = (value: unknown): value is DateRange =>
    typeof value === 'object' && value !== null && 'start' in value && 'end' in value;

export const MONTHS_RU = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
] as const;

export const WEEKDAYS_RU = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'] as const;

export const toIsoDate = (date: Date): IsoDate =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const fromIsoDate = (value: IsoDate): Date => {
    const [year, month, day] = value.split('-').map(Number);

    return new Date(year, month - 1, day);
};

export const formatRuDate = (value: IsoDate): string => {
    const [year, month, day] = value.split('-');

    return `${day}.${month}.${year}`;
};

export const formatDateRangeLabel = (range: DateRange | null, placeholder = 'Выберите период'): string =>
    range ? `${formatRuDate(range.start)} — ${formatRuDate(range.end)}` : placeholder;

export const startOfDay = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const startOfMonth = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), 1);

export const addMonths = (date: Date, amount: number): Date =>
    new Date(date.getFullYear(), date.getMonth() + amount, 1);

export const isSameDay = (a: Date, b: Date): boolean =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const buildMonthGrid = (month: Date): Date[] => {
    const first = startOfMonth(month);
    const shift = (first.getDay() + 6) % 7;
    const gridStart = new Date(first.getFullYear(), first.getMonth(), 1 - shift);

    return Array.from(
        { length: 42 },
        (_, index) => new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + index),
    );
};

export const pluralRu = (count: number, forms: [string, string, string]): string => {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod10 === 1 && mod100 !== 11) return forms[0];
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];

    return forms[2];
};